import { generatePaperViewHref, generatePatentViewHref, generateReportViewHref } from '@eureka/utils/view';
import type { ISolution } from '../types';
import { SOLUTION_TYPE } from '../types';

export function normalizeSolutionOrgInfo(solution: ISolution) {
    if (solution?.SOLUTION_TYPE === SOLUTION_TYPE.PATENT) {
        return solution
    }
    const orgs = solution.ORG_INFO?.map(org => ({
        display_name: org.normalized_display_name,
        id: org.normalized_id,
        logo: org.normalized_logo,
    }));
    return {
        ...solution,
        ORG_INFO: orgs,
    }
}

export function getSolutionLink(solution: ISolution) {
    if (solution.SOLUTION_TYPE === SOLUTION_TYPE.PATENT) { return generatePatentViewHref({ patentId: solution.SOLUTION_ID }) }
    if (solution.SOLUTION_TYPE === SOLUTION_TYPE.PAPER) { return generatePaperViewHref({ solutionId: solution.SOLUTION_ID }) }
    if (solution.SOLUTION_TYPE === SOLUTION_TYPE.REPORT) { return generateReportViewHref({ reportId: solution.SOLUTION_ID }) }
    return solution?.LINK
}
